export const SUBJECT_TAXONOMY = {
  science: [
    "physics",
    "chemistry",
    "biology",
    "botany",
    "zoology",
    "biotechnology"
  ],

  commerce: [
    "accountancy",
    "accounts",
    "commerce",
    "economics",
    "business studies",
    "bst",
    "finance"
  ],

  arts: [
    "history",
    "geography",
    "political science",
    "civics",
    "sociology",
    "psychology",
    "philosophy"
  ],

  maths: [
    "maths",
    "math",
    "mathematics",
    "arithmetic",
    "statistics"
  ],

  computer: [
    "computer",
    "computer science",
    "cs",
    "it",
    "informatics",
    "software"
  ],

  languages: [
    "english",
    "english language",
    "hindi",
    "kannada",
    "tamil",
    "telugu",
    "sanskrit"
  ]
};
